import React from 'react';
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import { FiCheck } from "react-icons/fi";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ContactOne from "../elements/contact/ContactOne";
import ScrollAnimation from "react-animate-on-scroll";


const MemAffiliates = () => {
    return (
        <>
            <SEO title="Events" />
            <Layout>
                <BreadcrumbOne 
                    title="Membership for Affiliates"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Membership for Affiliates"
                />
                <div className="row row--30 mt--30" style={{padding:"30px"}}>
            <div className="col-lg-6 col-md-5 col-sm-4 col-12 bg-color-white radius">
            <div className="split-inner" style={{padding:"30px"}}>
            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">UFTAA offers opportunity for individual agencies/ companies listed below who are most welcome to join as "Affiliate Members". The industry's exponential growth has impacted UFTAA to admit affiliate members (individual agencies) to offer them global networking opportunities. Seller meets Buyers through UFTAA can be a highly dependable experience as we deal in travel & tourism. Such affiliate members can easily create their own consortiums; exchange services; and connect with services that are highly beneficial. UFTAA will provide events/forums for hand-shake and B-to-B interact opportunities. Affiliate membership is a great way for agencies/companies to go global and remain connected. </p>
                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <h6 style={{fontsize:"20px"}}>Affiliate Members are welcome from all fields of Travel & Tourism Industry. Some categories are listed below and these must be individual organizations.</h6>
                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                 <ul className="feature-list">
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Travel agencies</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> 	Tour operators (inbound and outbound)</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Hotels/ Resorts</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Hospitality providers (Non Chain)/ promoters/ selling agencies/ .com companies</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Tours/ Sight-seeing operators</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Tourism Agencies/ DMCs</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Specialized Tourism Agencies featuring sports; medical; wellness; adventure; wild-life/safaris etc.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Cruise sales promoters </p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> MICE/ Meetings/ Congresses/ Exhibition/ Event organizers </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Transport/coach/Car/Cabs/Limo companies </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Technology providers - Web Designing & Management / Portal providers / Back-end support to agencies/companies</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Allied service providers including ".com or online companies"</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Education providers - Authorized Training Centers in Travel & Tourism Training / Training institutes supporting skills development or related fields</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Universities/Colleges offering Travel; Tourism or Hospitality Management</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Professionals Training Centers for Aviation Staff - Inflight attendants - Travel & Tourism etc</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Global Placement Companies</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Visa Services providers</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Foreign Exchange/ Credit or Debit Card providers</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Communication companies - Global Calling Cards or Sim Card providers</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Meet & Assist Agencies at Airports/ Cities</p>
                                        </div>
                                    </li>
                                </ul>
                            </ScrollAnimation>
                          
                        </div>
            </div>
            <div className="col-lg-6 col-md-5 col-sm-4 col-12 bg-color-white radius" style={{padding:"30px"}}>
            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                            <h5 style={{fontsize:"30px", fontWeight:"bold"}}>Annual Fees</h5>

                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">Annual Membership fee for Affiliate Members is discounted to applicants who are members of an association that is already a member of UFTAA. (An UFTAA ID Card with our compliments - for one nominee of the Applicant)</p>
                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                            <h6 style={{fontsize:"30px", fontWeight:"bold"}}>One-time admission fee of € 70</h6>
                            <h6 style={{fontsize:"30px", fontWeight:"bold"}}>Applicants who are members of UFTAA ASSOCIATION MEMBER : € 100</h6>
                            <h6 style={{fontsize:"30px", fontWeight:"bold"}}>Applicants who are stand-alone agencies and not members of an UFTAAASSOCIATION MEMBER : € 150.</h6>

                            </ScrollAnimation>
                            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScZe-jNXB2Nyo-yaUgKt0IARxSjhTC4XnE0JmbLiAgyKix0hA/viewform?embedded=true" width="640" height="1236" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            </div>
            </div>
           
        </Layout>
        </>
    )
}
export default MemAffiliates;